const isSessionMeetingId = id => id.startsWith('s-mg-');

export default isSessionMeetingId;
